"use client";

import { createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { LOCAL_STORAGE_KEY } from "../../lib/constant/constant";
import { getPrimaryColor, savePrimaryColor } from "@/lib/utils";

let userToken = null;
let userInfo = null;
if (typeof window !== "undefined") {
  userToken =
    localStorage.getItem(LOCAL_STORAGE_KEY.AUTH_TOKEN) ||
    sessionStorage.getItem(LOCAL_STORAGE_KEY.AUTH_TOKEN);
  userInfo =
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO)) ||
    JSON.parse(sessionStorage.getItem(LOCAL_STORAGE_KEY.USER_INFO));
}

const initialState = {
  userToken,
  userInfo,
  isAuthenticated: !!userToken,
  isLoading: false,
  error: null,
  // Currently selected tenant's branding color.
  primaryColor: "#00D3F1",

  // Keeps tenant colors separated in Redux.
  primaryColorsByTenant: {},
};

// Create the Auth Slice
export const globalSlice = createSlice({
  name: `Global Data`,
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload.info;
      state.userToken = action.payload.token;
      state.userDetails = action.payload.userDetails;
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
    },
    loadPrimaryColor: (state, action) => {

      const { tenantId, primaryColor: apiPrimaryColor } = action.payload || {};

      if (!tenantId) return;

      /*
       * Important:
       * When the API provides a color, it is the latest
       * tenant branding color and must replace cached data.
       */
      const resolvedColor =
        apiPrimaryColor || getPrimaryColor(tenantId) || "#00D3F2";

      state.primaryColor = resolvedColor;

      state.primaryColorsByTenant[String(tenantId)] = resolvedColor;

      if (apiPrimaryColor) {
        savePrimaryColor(tenantId, apiPrimaryColor);
      }
    },

    setPrimaryColor: (state, action) => {
      const { tenantId, primaryColor } = action.payload || {};

      if (!tenantId || !primaryColor) return;

      state.primaryColor = primaryColor;

      state.primaryColorsByTenant[String(tenantId)] = primaryColor;

      // Always overwrite the old cached tenant color.
      savePrimaryColor(tenantId, primaryColor);
    },

    logout: (state) => {
      localStorage.removeItem(LOCAL_STORAGE_KEY.AUTH_TOKEN);
      localStorage.removeItem(LOCAL_STORAGE_KEY.USER_INFO);
      sessionStorage.removeItem(LOCAL_STORAGE_KEY.AUTH_TOKEN);
      sessionStorage.removeItem(LOCAL_STORAGE_KEY.USER_INFO);
      state.userToken = null;
      state.userInfo = null;
      state.userDetails = null;
      state.isAuthenticated = false;
      toast.success("Successfully logged out");
      setTimeout(() => {
        window.location.href = "/auth/login";
      }, 300);
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  logout,
  setUserInfo,
  setLoading,
  setError,
  clearError,
  setPrimaryColor,
  loadPrimaryColor,
} = globalSlice.actions;

// Export thunk actions

export default globalSlice.reducer;
